import type { PortalToolHandler } from './types';

export class PortalToolRegistry {
  private readonly handlers = new Map<string, PortalToolHandler>();

  register(toolName: string, handler: PortalToolHandler): void {
    this.handlers.set(toolName, handler);
  }

  getHandler(toolName: string): PortalToolHandler | undefined {
    return this.handlers.get(toolName);
  }

  hasHandler(toolName: string): boolean {
    return this.handlers.has(toolName);
  }
}

export const portalToolRegistry = new PortalToolRegistry();
